import styles from './BenefactorPointsAndRatingSection.module.scss';
import {BenefactorPointsAndRating} from '../BenefactorPointsAndRating';
import {BenefactorPointsAssignmentHistory} from '../BenefactorPointsAssignmentHistory';
import {Text} from '@gravity-ui/uikit';

interface BenefactorPointsAndRatingSectionProps {
  benefactorId: string | undefined;
}

export const BenefactorPointsAndRatingSection = ({benefactorId}: BenefactorPointsAndRatingSectionProps) => {
  return (
    <div className={styles.container}>
      <BenefactorPointsAndRating benefactorId={benefactorId} />
      <div className={styles.historySection}>
        <Text variant="header-2" className={styles.historyTitle}>
          История выдачи очков
        </Text>
        <BenefactorPointsAssignmentHistory benefactorId={benefactorId} />
      </div>
    </div>
  );
};
